import React from 'react';
import { Link } from 'gatsby';

const siteConfig = require(`~/data/site/site.${process.env.GATSBY_SITE}.json`);

const ToolkitsLabel = ({ item, embedMode }) => {
	return (
		<div className="font-bold uppercase text-xs text-card-product-toolkitHeadline-default mb-1">
			{item.Toolkits && item.Toolkits.length > 0 && (
				<>
					<p className="inline-block mr-1 text-gray-500">
						{item.Toolkits.length > 1
							? `Part of these ${siteConfig.toolkitTerms.collections.toLowerCase()}:`
							: 'Part of the'}
					</p>

					<ul className="inline">
						{item.Toolkits.map(toolkit => (
							<li
								key={`toolkit-${toolkit.data.Name}`}
								className={`
									inline
									${
										item.Toolkits.length > 1 &&
										'after:content-[","] after:inline-block after:mr-1 last:after:content-[""]'
									}
								`}
							>
								{toolkit.data.Slug ? (
									<>
										{embedMode ? (
											<a
												href={`/${siteConfig.toolkitTerms.route}/${toolkit.data.Slug}`}
												className="transition-colors hover:text-card-product-toolkitHeadline-hover hover:underline focus:text-card-product-toolkitHeadline-hover focus:underline"
												target="_blank"
												rel="noreferrer"
											>
												{toolkit.data.Name.includes('Toolkit')
													? toolkit.data.Name
													: `${toolkit.data.Name} ${siteConfig.toolkitTerms.collection}`}
											</a>
										) : (
											<Link
												to={`/${siteConfig.toolkitTerms.route}/${toolkit.data.Slug}`}
												className="transition-colors hover:text-card-product-toolkitHeadline-hover hover:underline focus:text-card-product-toolkitHeadline-hover focus:underline"
											>
												{toolkit.data.Name.includes('Toolkit')
													? toolkit.data.Name
													: `${toolkit.data.Name} ${siteConfig.toolkitTerms.collection}`}
											</Link>
										)}
									</>
								) : (
									toolkit.data.Name
								)}
							</li>
						))}
					</ul>
				</>
			)}
		</div>
	);
};

export default ToolkitsLabel;
